export { AtnMappingTabComponent as Component } from './mapping-tab.component'
